module.exports = __webpack_public_path__ + "static/img/OTTAWA_OAK.3c30833.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/OTTAWA_OAK.jpg
// module id = fQEz
// module chunks = 0